const { hostname } = window.location;

export const isLocalHost = (host: string): boolean =>
  host === "localhost" ||
  host === "127.0.0.1" ||
  /^192\.168\.\d{1,3}\.\d{1,3}$/.test(host) ||
  /^172\.(1[6-9]|2\d|3[01])\.\d{1,3}\.\d{1,3}$/.test(host);

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  host: isLocalHost(hostname) ? hostname : `.${hostname.replace(/^\w+\./, "")}`,
  api: {
    url: {
      production: "https://middlewarecliente.grupoatem.com.br/rest",
      homologation: "http://localhost:8080/rest",
      development: "https://middlewarecliente-dev.grupoatem.com.br/rest",
      local: `http://localhost:${
        process.env.REACT_APP_MIDDLEWARE_PORTAL_CLIENTE_PORT || "3333"
      }/rest`,
    },
    urlPump: {
      production: "https://pump.grupoatem.com.br/rest/",
    },
    urlCognito: {
      production: "https://gateway.grupoatem.com.br",
      homologation: "https://gateway-dev.grupoatem.com.br",
      development: "https://gateway-dev.grupoatem.com.br",
    },
    timeout: 300000,
  },
  cognito: {
    gateway: {
      production: "https://gateway.grupoatem.com.br",
      homologation: "http://localhost:8080TESTE",
      development: "https://gateway-dev.grupoatem.com.br",
    },
    urlLogout: {
      development: `http://${window.location.hostname}:3000/#/logout?url=http://${window.location.hostname}:3001&rules=portal_cliente`,
      localDev:
        "https://authcog-dev.grupoatem.com.br/#/logout?url=https://local-portal-dev.grupoatem.com.br:3000&rules=portal_cliente",
      homologation:
        "https://authcog-dev.grupoatem.com.br/#/logout?url=https://portal-dev.grupoatem.com.br&rules=portal_cliente",
      production:
        "https://authcog.grupoatem.com.br/#/logout?url=https://portal.grupoatem.com.br&rules=portal_cliente",
    },
  },
  keyStorage: {
    newOrderData: "@portal-client:newOrderData",
    auth: { token: "@ATEM:portal-client:token" },
  },
};

export const compartmentsAvailable = [...new Array(12)].map(
  (_, i) => `${i + 1}`
); // array from 1 to 1

console.info(`Running using ENV=${process.env.REACT_APP_ENVIRONMENT}`);

export const isDevelopment =
  process.env.REACT_APP_ENVIRONMENT === "development" ||
  process.env.REACT_APP_ENVIRONMENT === "local" ||
  isLocalHost(hostname) ||
  Boolean(window.location.origin.split(".")[0].match(/-dev$/));

export const nameLogin = localStorage.getItem("nameLogin");
